import React, { createContext, useContext, useState } from 'react';

// Create a context for Parent Style criteria
const ParentStyleContext = createContext();

// Custom hook to use the ParentStyleContext
export const useParentStyleCriteria = () => useContext(ParentStyleContext);

// Provider component
export const ParentStyleCriteriaProvider = ({ children }) => {
  const [padding, setPadding] = useState('20px');

  return (
    <ParentStyleContext.Provider value={{ padding, setPadding }}>
      {children}
    </ParentStyleContext.Provider>
  );
};
